import { LegalPage } from '@/pages/LegalLayout';

export default function CookiePolicy() {
  return <LegalPage base="legal.cookies" />;
}
